/* Exit-intent popup — fires when user moves mouse to top of viewport (desktop)
   or after deep scroll without conversion (mobile fallback).
   Offers the Free Janma Kundli lead magnet. */
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X, Stars } from "lucide-react";

const KEY = "vv_exit_seen_v1";

export default function ExitIntentPopup() {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (localStorage.getItem(KEY)) return;

        let armed = false;
        const arm = () => { armed = true; };
        const armTimer = setTimeout(arm, 12000); // arm after 12s

        // Desktop: mouseleave to top
        const onMouseOut = (e) => {
            if (!armed) return;
            if (e.clientY <= 0 && !e.relatedTarget && !e.toElement) {
                setOpen(true);
                document.removeEventListener("mouseout", onMouseOut);
            }
        };
        // Mobile: deep scroll then scroll back up quickly
        let lastY = window.scrollY;
        const onScroll = () => {
            if (!armed) return;
            const y = window.scrollY;
            if (y < lastY - 80 && y < 200 && document.body.scrollHeight > 1500) {
                setOpen(true);
                window.removeEventListener("scroll", onScroll);
            }
            lastY = y;
        };
        document.addEventListener("mouseout", onMouseOut);
        window.addEventListener("scroll", onScroll, { passive: true });

        return () => {
            clearTimeout(armTimer);
            document.removeEventListener("mouseout", onMouseOut);
            window.removeEventListener("scroll", onScroll);
        };
    }, []);

    const close = () => {
        localStorage.setItem(KEY, "1");
        setOpen(false);
    };

    if (!open) return null;
    return (
        <div className="fixed inset-0 z-[80] grid place-items-center px-4 bg-black/75 backdrop-blur-sm animate-in fade-in" data-testid="exit-popup">
            <div className="relative w-full max-w-lg rounded-3xl border border-gold/40 bg-ink-deep p-8 shadow-2xl">
                <button onClick={close} className="absolute top-4 right-4 text-cream-muted hover:text-gold" data-testid="exit-popup-close" aria-label="Close">
                    <X className="h-5 w-5" />
                </button>
                <div className="flex justify-center mb-4">
                    <div className="h-16 w-16 rounded-full bg-gold/15 border border-gold/40 grid place-items-center">
                        <Stars className="h-8 w-8 text-gold" />
                    </div>
                </div>
                <h3 className="font-serif text-2xl sm:text-3xl text-cream text-center leading-tight">
                    Wait — Your Free <span className="italic text-gold">Janma Kundli</span> Awaits
                </h3>
                <p className="text-sm text-cream-muted text-center mt-4 leading-relaxed">
                    Discover your <strong className="text-cream">Janma Rashi</strong>, <strong className="text-cream">Nakshatra</strong>, lucky color, gemstone, and one personalized Vedic remedy — generated by Dr. Tannu's Vedic AI in seconds. Absolutely free.
                </p>
                <div className="mt-6 flex flex-col gap-3">
                    <Link to="/free-kundli" onClick={close} className="btn-gold w-full text-sm" data-testid="exit-popup-cta">
                        Get My Free Kundli →
                    </Link>
                    <button onClick={close} className="text-xs text-cream-dim hover:text-gold py-2" data-testid="exit-popup-skip">
                        No thanks, I'll leave
                    </button>
                </div>
            </div>
        </div>
    );
}
